import { defineMessages } from 'react-intl-next';

export default defineMessages({
    emptyStateDescription: {
        defaultMessage: 'When your customers start raising requests, recently used request forms will show up here.',
        description: 'Description message for suggested request forms empty state',
        id: 'hc.customization.suggested-request-forms.empty-state-description',
    },
});
